<div #animatedDigit class="animated-digit" (click)="reloadDigit()">
  <div kvisVisible [elementVisible]="isVisible" (elementVisibleChange)="isVisibleSignal.set($event)">
    <span>{{ digit }}</span>
  </div>
</div>
